/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const SupplierStateFilterDefault = `ACTIVE`;

export const SupplierStateFilter = zod
  .enum(["ACTIVE", "DELETED", "ALL"])
  .default(SupplierStateFilterDefault);

export type SupplierStateFilter = zod.input<typeof SupplierStateFilter>;
export type SupplierStateFilterOutput = zod.output<typeof SupplierStateFilter>;
